module.exports = __webpack_public_path__ + "static/media/dbk.007c7c8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dbk.svg
// module id = 112
// module chunks = 0